/**
 * Tell Timo how it was opened: from a notification, an email, a shared link, the Chrome extension,
 * or directly. One report per visit, plus one when someone comes back to a tab left open for half
 * an hour. This and the meetings themselves are all the return-odds score reads.
 */
import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";

const track = httpsCallable<Record<string, string>, { ok: boolean }>(functions, "trackActivity");
const AWAY_MS = 30 * 60_000;
let reported = false;
let hiddenAt = 0;

function sourceFromUrl(): { source: string; nudgeId?: string } {
  const q = new URLSearchParams(location.search);
  const from = q.get("from"), n = q.get("n") ?? undefined;
  // Read once, then take them out of the address bar so a reload or a copied link doesn't count again.
  if (from || n) {
    q.delete("from"); q.delete("n");
    history.replaceState(null, "", `${location.pathname}${q.size ? `?${q}` : ""}${location.hash}`);
  }
  if (from === "push") return { source: "notification", nudgeId: n };
  if (from === "email") return { source: "email", nudgeId: n };
  if (q.get("desktop") === "1") return { source: "extension" };
  if (/\/notes\/|utm_source/.test(document.referrer) || /utm_source/.test(location.search)) return { source: "link" };
  return { source: "icon" };
}

/** Call once the person is signed in. */
export function trackOpens() {
  if (reported) return;
  reported = true;
  const first = sourceFromUrl();
  void track({ event: "open", platform: "web", ...first } as Record<string, string>).catch(() => {});
  document.addEventListener("visibilitychange", () => {
    if (document.hidden) { hiddenAt = Date.now(); return; }
    if (hiddenAt && Date.now() - hiddenAt > AWAY_MS) void track({ event: "open", platform: "web", source: "icon" }).catch(() => {});
    hiddenAt = 0;
  });
}
